module.exports = __webpack_public_path__ + "img/zizhi24.dc424ab9.png";